module.exports = {
  "calendar": "Kalendorius",
  "day": "diena",
  "dayPeriod": "iki piet\u0173 / po piet\u0173",
  "endDate": "Pabaigos data",
  "era": "era",
  "hour": "valanda",
  "minute": "minut\u0117",
  "month": "m\u0117nuo",
  "second": "sekund\u0117",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Pasirinkta data: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Pasirinktas intervalas: nuo ".concat(args.startDate, " iki ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Pasirinktas laikas: ".concat(args.time);
  },
  "startDate": "Prad\u017Eios data",
  "timeZoneName": "laiko juosta",
  "weekday": "savait\u0117s diena",
  "year": "metai"
};